/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import styles from './summary.module.scss';
import { Divider, Checkbox, Tooltip } from '@mui/material';
import HDFCERGO from '../../../../../Assets/images/svg/dar_hdfc_ergo.svg';
import MagnifyingGlass from '../../../../../Assets/images/svg/dar_magnify.svg';
import Duration from '../../../../../Assets/images/svg/dar_duration.svg';
import FlutterFlow from '../../../../../Assets/images/svg/dar_flutter_flow.svg';
import NodeJS from '../../../../../Assets/images/svg/dar_node_js.svg';
import Breakdown from './breakdown';
import { AuthContext } from '../../../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../../../Constants/modules';
import UseAxios from '../../../../../Api/http/http';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useSnackbar } from '../../../../../Components/Snackbar/snackBarProvider';
import Signed from '../../../../../Assets/images/svg/dar_signed.svg';
import Rejected from '../../../../../Assets/images/svg/dar_reject.svg';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import AddApproval from '../../../DealApproval/approvalPopup';
import {
  patchOtherEffort,
  getSummary,
  submitEfforts,
} from '../../../../../Api/request/dealEffort';
import { getDealEffortReviewers } from '../../../../../Api/request/approval';

export default function Summary() {
  const handleCheckboxClick = async(params) => {
    const payload = { enable: !params.row.inScope };
    try {
      const res = await UseAxios(patchOtherEffort(params.row.id, payload));
      if (res.status === 200) {
        await fetchSummaryData();
      }
    } catch (err) {
      console.error('Error fetching data:', err);
    }
  };

  const columns = [
    {
      field: 'srno',
      headerName: 'Sr. No.',
      width: 250,
      headerClassName: styles.header,
      cellClassName: `${styles.cell} ${styles.srnoCell}`,
    },
    {
      field: 'task',
      headerName: 'Task',
      minWidth: 200,
      flex: 1,
      headerClassName: styles.header,
      cellClassName: styles.cell,
    },
    {
      field: 'inScope',
      headerName: 'In Scope?',
      width: 150,
      renderCell: (params) =>
        params.row.srno === 'Total Effort (Person Days)' ? (
          ''
        ) : (
          <Checkbox
            checked={params.row.inScope}
            disabled={!params.row.editable}
            onChange={() => handleCheckboxClick(params)}
            sx={{
              '&.Mui-disabled': {
                color: '#6b5ce8',
                opacity: 0.6,
                cursor: 'auto',
              },
              '&:not(.Mui-disabled)': {
                color: '#6b5ce8',
                opacity: 1,
                cursor: 'pointer',
              },
              '& .MuiSvgIcon-root': {
                borderRadius: '4px',
                height: '20px',
                width: '20px',
              },
            }}
          />
        ),
      headerClassName: styles.header,
      cellClassName: (params) =>
        params.row.srno === 'Total Effort (Person Days)'
          ? styles.totalRow
          : styles.cell,
    },
    {
      field: 'totalEfforts',
      headerName: 'Estimated Efforts (Days) ',
      width: 200,
      headerClassName: styles.header,
      cellClassName: styles.cell,
    },
  ];
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const { snackbarOpen } = useSnackbar();

  const query = useQuery();
  const DEAL_ID = query.get('id');

  const [rows, setRows] = useState([]);
  const [data, setData] = useState({});
  const [reviewerList, setReviewerList] = useState([]);
  const [approvalList, setApprovalList] = useState([]);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [isApprovalFlow, setIsApprovalFlow] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(true);

  const { userProfile } = useContext(AuthContext);
  const location = useLocation();
  const userId = userProfile.userPortalId;
  const roleNames = userProfile?.roleDetails?.map(role => role.roleName) || [];

  const usePermissions = (moduleName) => {
    return userProfile?.permissions ? userProfile.permissions[moduleName] || [] : [];
  };

  const effortEstimatePermissions = usePermissions(MODULE_NAMES.DEAL_TRANSITION_EFFORT_ESTIMATION);
  const efforApprovalPermissions = usePermissions(MODULE_NAMES.DEAL_TRANSITION_DEAL_EFFORT_APPROVAL);

  const hasAccess = (action) => effortEstimatePermissions.includes(action);
  const hasApprovalAccess = (action) => efforApprovalPermissions.includes(action);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };


  useEffect(() => {
    // Set selected tab from router state if available    
    if (location.state?.isApprovalFlow) {
        setIsApprovalFlow(true);
    }
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-GB', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  };
  
  const formatTime = (dateString) => {
    return new Date(dateString).toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).toUpperCase(); // Makes AM/PM uppercase
  };

  const renderApproverStatus = (approver, index) => {
    const getStatusIcon = (status) => {
      switch(status) {
        case 'Approved':
          return <img src={Signed} alt="Signed" className={styles['summary-status-img']}/>;
        case 'Rejected':
          return <img src={Rejected} alt="Rejected" className={`${styles['summary-status-img']} ${styles[status]}`}/>;
        default:
          return <img src={Signed} alt="Signed" className={styles['summary-status-img']}/>;
      }
    };
  
    return (
      <div className={styles['approver-container']} key={`${approver.reviewedBy}-${index}`}>
        <div className={styles['flex-gap']}>
          <div className={styles['flex-align-center']}>
            <div>
              {getStatusIcon(approver.status)}
            </div>
            <div className={styles['approver-details']}>
              <div className={[styles['flex-align-center'], styles['bg-none']].join(' ')} 
                   aria-label="Open dialog">
                <div className={`${styles['awaiting-approval']} ${styles[approver.status]}`}>
                  {!approver.status ? 'Submitted By' : `${approver.status} By`}
                </div>
                <div className={styles['approver-role-details']}>
                <div className={styles['color-block']} 
                     style={{ background: '#8B7DFE' }} />
                <div className={styles['name-role']}>{approver.reviewedByRole}</div>
                <Divider orientation="vertical" flexItem />
                <div className={styles['name']}>{approver.reviewedBy}</div>
              </div>
              </div>
              <div className={styles['flex-align-center']}>
                <div className={styles['time-status']}>
                {formatDate(approver.reviewedAt)}
                </div>
                <Divider orientation="vertical" flexItem />
                <div className={styles['time-status']}>
                {formatTime(approver.reviewedAt)}
                </div>
                {approver.comment && (
                  <>
                    <Divider orientation="vertical" flexItem />
                    <Tooltip
                        title={
                          <div>
                            <span className={styles['summary-comment']}>Comment: </span>
                            {approver.comment}
                          </div>
                        }
                      classes={{ tooltip: styles['summary-comment-tooltip'] }}
                    >
                      <Tooltip>
                        <div className={styles['view-comments']}>
                          View Comments
                      </div>
                      </Tooltip>
                    </Tooltip>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        {index !== reviewerList.length - 1 && 
        <KeyboardArrowRightIcon className={styles['summary-arrow']}/>}
      </div>
    );
  };

  const fetchSummaryReviewerData = async () => {
    try {
      const res = await UseAxios(getDealEffortReviewers(DEAL_ID));
      const responseData = res.data;
      if(!responseData.success) {
        setIsSubmitted(false);
      }
      setApprovalList(responseData.reviewList);
        // Create submitted data object
      const submittedData = {
        reviewedBy: responseData.submittedBy,
        reviewedByRole: capitalizeFirstLetter(responseData.roleName),
        reviewedAt: responseData.effortSubmittedOn,
      };

      const transformedReviewList = responseData.reviewList
      .filter(review => review.status !== 'PENDING')
      .map(review => ({
        ...review,
        status: capitalizeFirstLetter(review.status)
      }));

      // Combine submitted data with modified review list
      const finalReviewList = [submittedData, ...transformedReviewList];
      setReviewerList(finalReviewList);
    } catch (err) {
      console.error('Error fetching reviewer data:', err);
    }
  };

    const fetchSummaryData = async () => {
      try {
        const res = await UseAxios(getSummary(DEAL_ID));
        const responseData = res.data.response;
        setData(responseData);
        const tasksWithSrno = responseData.tasks.map((task, index) => ({
          ...task,
          srno: index + 1,
        }));

        tasksWithSrno.push({
          id: -999,
          srno: 'Total Effort (Person Days)',
          task: '',
          inscope: '',
          totalEfforts: `${responseData?.effortStats?.days?.totalEfforts}`,
        });

        setRows(tasksWithSrno);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

  useEffect(() => {
    fetchSummaryReviewerData();
    fetchSummaryData();
  }, []);

  const [searchInput, setSearchInput] = useState('');

  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  const filteredData = rows.filter((item) =>
    (item.task || '').toLowerCase().includes(searchInput.toLowerCase())
  );

  const handleSubmit = async () => {
    try {
      const res = await UseAxios(submitEfforts(DEAL_ID, userId));
      if (res.status === 200) {
        snackbarOpen('Deal Efforts submitted successfully', 'success');
      } else {
        snackbarOpen(
          'Deal Effort could not be submitted please try again',
          'error'
        );
      }
    } catch (error) {
      console.error(
        'Deal Effort could not be submitted please try again',
        error
      );
      snackbarOpen(
        'Deal Effort could not be submitted please try again',
        'error'
      );
    }
  };

  // Add this function to check if the reviewal is activated
  const getReviewalActivated = (roleNames) => {
    return approvalList?.some(review => 
      roleNames.some(roleName => 
        roleName.toLowerCase() === review.reviewedByRole.toLowerCase() && review.reviewalActivated
      )
    );
  };

  // Add this function to get the active approval ID
  const getActiveApprovalId = () => {
    if (!approvalList?.length) return null;
    
    const activeApproval = approvalList.find(review => 
      roleNames.some(roleName => 
        roleName.toLowerCase() === review.reviewedByRole.toLowerCase() && review.reviewalActivated
      )
    );
    
    return activeApproval?.id || null;
  };

  return (
    <div>
      <div className={styles['data-grid-container']}>
        <div className={styles['top-container']}>
            {/* Approver Container */}
          {reviewerList?.length > 0 && (
            <div className={styles['approver-list']}>
            {reviewerList.map((approver, index) => 
              renderApproverStatus(approver, index)
            )}
            </div>
          )}
          <div className={styles.header}>Deal Details</div>
          <Divider sx={{ borderColor: 'white', width: '100%' }} />
          {/* Container-1 */}
          <div className={styles['top-container-1']}>
            <div className={styles['logo-project-name']}>
              {data.dealDetails?.logourl ? (
                <div className={styles['logo']}>
                  <img src={HDFCERGO} alt="HDFC ERGO" />
                </div>
              ) : null}

              <div className={styles['name-effort']}>
                <div className={styles['name']}>
                  {' '}
                  {data.dealDetails?.dealName}
                </div>
                <div className={styles['efforts']}>
                  <img
                    src={Duration}
                    alt="Duration"
                    className={styles['effort-icon']}
                  />
                  {data.effortStats?.days?.totalEfforts}{' '}
                  {data.effortStats?.days?.totalEfforts === 1
                    ? 'Man day'
                    : 'Man days'}
                </div>
              </div>
            </div>
            {data.dealDetails?.techstack ? (
              <div className={styles['tech-stack-container']}>
                <div className={styles['text']}>Tech Stack</div>
                <div className={styles['tech-stack-list']}>
                  <div className={styles['tech-stack']}>
                    <img
                      src={FlutterFlow}
                      className={styles['image']}
                      alt="Flutter Flow"
                    />{' '}
                    FlutterFlow
                  </div>
                  <div className={styles['tech-stack']}>
                    <img
                      src={NodeJS}
                      className={styles['image']}
                      alt="NodeJS"
                    />{' '}
                    Node JS
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          {/* Container-2 */}
          <div className={styles['top-container-2']}>
            <div className={styles['project-duration']}>
              <div className={styles['text']}>Project Duration</div>
              <div className={styles['flex-between']}>
                <div className={styles['denomination']}>
                  {data.effortStats?.days?.totalEfforts} Person days{' '}
                  <span className={styles['bracket']}>
                    {data?.effortStats?.days?.duration}{' '}
                  </span>
                </div>
              </div>
            </div>
            <Divider orientation="vertical" flexItem />
            <div className={styles['project-duration']}>
              <div className={styles['text']}>Last Updated</div>
              <div className={styles['flex-between']}>
                <div className={styles['denomination']}>
                  {data.dealDetails?.addedBy}{' '}
                  <span className={styles['bracket']}>
                    {`(${formatDate(data.dealDetails?.latestUpdated)})`}{' '}
                  </span>
                </div>
                {data.dealDetails?.history ? (
                  <div className={styles['view-history']}>View History</div>
                ) : null}
              </div>
            </div>
          </div>
          {/* Container-3 */}
          <Breakdown data={data.effortStats} />
        </div>
        <div className={styles['search-container']}>
          <div className={styles['total-project-efforts']}>
            Total Project Efforts
          </div>
          <div className={styles['certification-search']}>
            <img src={MagnifyingGlass} alt="Search" />
            <input
              id="certification-search-input"
              type="text"
              placeholder="Search..."
              onChange={handleSearchInputChange}
            />
          </div>
        </div>
        <div className={styles['data-grid']}>
          <DataGrid
            disableDensitySelector
            disableRowSelectionOnClick
            disableColumnSorting={true}
            disableColumnMenu
            className={styles.dataGrid}
            rows={filteredData}
            columns={columns}
            disableSelectionOnClick={true}
            editMode="cell"
            pagination={false}
            hideFooter={true}
            rowHeight={52}
            sx={{
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#F1F5F8 !important',
              },
              '& .MuiDataGrid-columnHeader': {
                backgroundColor: '#F1F5F8 !important',
              },
              '& .MuiDataGrid-row:nth-of-type(even)': {
                backgroundColor: '#F1F5F8',
              },
              '& .MuiDataGrid-row:nth-of-type(odd)': {
                backgroundColor: '#ffff',
              },
              '& .MuiDataGrid-columnSeparator': {
                display: 'none',
              },
              '& .MuiDataGrid-row:last-child': {
                backgroundColor: '#ECEDF4',
              },
              '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
                {
                  outline: 'none',
                },
            }}
          />
        </div>
      </div>
      <div className={styles['sticky-save-button']}>
      {!isSubmitted && (
        <button
          className={styles['submit-button']}
          disabled={!hasAccess('update')}
          onClick={handleSubmit}
        >
          Submit
        </button>
      )}
        {isApprovalFlow && getReviewalActivated(roleNames) && (
          <button
          className={styles['submit-button']}
          onClick={() => setAddModalOpen(true)}
          disabled={!hasApprovalAccess('create')}
        >
          Proceed
        </button>
        )}
      </div>
      <AddApproval // AddApproval popup
        approvalId={getActiveApprovalId()}
        userId={userId}
        isEffortPopup={true}
        modalOpen={addModalOpen}
        handleClose={() => setAddModalOpen(false)}
        updatedData={fetchSummaryReviewerData}
      />
    </div>
  );
}

Summary.propTypes = {
  data: PropTypes.shape({
    effortStats: PropTypes.shape({
      days: PropTypes.shape({
        totalEfforts: PropTypes.number,
        duration: PropTypes.string,
      }),
      percent: PropTypes.shape({
        feEfforts: PropTypes.number,
        beEfforts: PropTypes.number,
        testingEfforts: PropTypes.number,
        pmEfforts: PropTypes.number,
        otherEfforts: PropTypes.number,
      }),
    }),
    dealDetails: PropTypes.shape({
      addedBy: PropTypes.string,
      latestUpdated: PropTypes.string,
    }),
    tasks: PropTypes.arrayOf(
      PropTypes.shape({
        srno: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        task: PropTypes.string,
        inscope: PropTypes.bool,
        totalEfforts: PropTypes.number,
      })
    ),
  }),
};
